import { makeStyles } from "@material-ui/core";

const stylePagesEmbalei = makeStyles((theme) => ({
  root: {},

  titlePage: {
    fontFamily: "",
    fontSize: 25,
    fontWeight: "bold",
    margin: "15px 0",
  },

  boxFilter: {
    "& .input-search": {
      width: 300,
    },

    "& > button": {
      marginTop: 17,
      marginLeft: 10,

      "&.no-margin": {
        marginTop: 0,
      },
    },
  },

  buttonsDowload: {
    marginBottom: '10px',
  },

  dateRanking: {
    marginRight: '5px',
  },

  totalOrders: {
    fontSize: 18,
    paddingBottom: 10,
    fontWeight: "bold",
  },

  exportExcel: {
    background: "#388e3c",
    margin: '20px 5px 10px 0',
    "&:hover": {
      background: "#388e3cdb",
    },
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3),
  },

  formField: {
    marginBottom: theme.spacing(2),
  },

  submitButton: {
    alignSelf: 'flex-start',
  },

  GridDate: {
    '&>div': {
      marginTop: '0px !important'
    }
  },

  tableGoalExpedition: {
    width: "100%",
    border: "1px solid #ccc",

    "& th, td": {
      padding: 10,
      fontSize: 18,
      border: "1px solid #ccc",
    },
  },
}));

export default stylePagesEmbalei;
